export default __webpack_public_path__ + "static/media/bitcoin-cash.5f0c4a96.svg";